import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useQuery } from '@vue/apollo-composable';
import * as Sentry from '@sentry/vue';

import GetUser from '@/gql/user/GetUser.gql';

export const useUserStore = defineStore(
  'user',
  () => {
    const user = ref(null);

    const userId = computed(() => (user.value ? user.value.id : null));
    const isAuthenticated = computed(() => (user.value ? true : false));
    const userInitials = computed(() =>
      user.value
        ? user.value.first_name[0].toUpperCase() ||
          user.value.email[0].toUpperCase()
        : ''
    );

    function updateUser(newUser) {
      if (newUser) {
        user.value = newUser;
        Sentry.setUser({
          id: user.value.id,
          email: user.value.email,
          full_name: `${user.value.first_name} ${user.value.last_name}`,
          first_name: user.value.first_name,
          last_name: user.value.last_name,
        });
      }
    }

    async function fetchUser(refetch = false) {
      return new Promise((resolve, reject) => {
        const fetchPolicy = refetch ? 'network-only' : 'cache-first';
        const { onResult, onError } = useQuery(GetUser, null, { fetchPolicy });
        onResult(({ data }) => {
          if (data) {
            const { user } = data;
            updateUser(user);
            resolve();
          }
        });
        onError((error) => {
          reject(error);
        });
      });
    }

    function reset() {
      user.value = null;
    }

    return {
      user,
      userId,
      userInitials,
      isAuthenticated,
      updateUser,
      fetchUser,
      reset,
    };
  },
  { persist: true }
);
